// ============================================================
// ROZŠÍŘENÁ OBJEDNÁVKA — overlay po přidání do košíku
// Shoptet vykreslí .advanced-order v colorboxu; JS přestaví obsah
// na kartu "produkt přidán" a doplní texty ze shopDataLayer.
// Styling viz components/advanced-order.scss (Figma node 1-437).
// ============================================================

// Při přidání do košíku ulož obrázek a cenu právě přidaného produktu
// (overlay je sám nenese — bereme je z detailu produktu)
document.addEventListener("ShoptetCartAddCartItem", function () {
    const $thumb = $(".p-thumbnails-inner > div > a:first-child > img");
    const $price = $(".p-detail-inner .p-final-price-wrapper");

    if ($thumb.length) {
        sessionStorage.setItem("ProductAddedImage", $thumb.attr("data-src") || $thumb.attr("src") || "");
    }

    if ($price.length) {
        sessionStorage.setItem("ProductAddedPrice", $price.html());
    }
});

// Po vykreslení overlaye přestav jeho obsah
document.addEventListener("ShoptetDOMContentLoaded", function () {
    if ($(".advanced-order").length > 0) {
        buildAdvancedOrder();
    }
});

// ============================================================
// Funkce: přestaví .advanced-order overlay na kartu "produkt přidán"
// Idempotentní — lze volat opakovaně bez duplikace
// ============================================================

function buildAdvancedOrder() {
    const config = getShopDataLayer().advancedOrder;

    // Hlavní nadpis (mimo doporučovací) — třída pro styling, text z datalayeru
    const $title = $(".advanced-order > .h1:not(.advanced-order-suggestion)").addClass("advanced-order__main-title");
    if (config.title) {
        $title.html(config.title);
    }

    // Karta produktu — obal názvu + vložení obrázku a ceny ze sessionStorage
    const $name = $(".h2[data-testid='textPopupProductName']");
    if ($name.length && $name.closest(".product-added").length === 0) {
        $name.wrap("<div class='product-added'></div>");

        const image = sessionStorage.getItem("ProductAddedImage");
        const price = sessionStorage.getItem("ProductAddedPrice");

        if (image) {
            $("<div class='img-holder'><img src='" + image + "' alt=''></div>").prependTo(".product-added");
        }

        if (price) {
            $("<div class='p-final-price-wrapper'>" + price + "</div>").appendTo(".product-added");
        }
    }

    // Tlačítka — texty z datalayeru (fallback: ponecháme Shoptet default)
    const $backBtn = $(".advancedOrder__buttons > button").addClass("btn-default");
    if (config.backToShoppingBtnText) {
        $backBtn.html(config.backToShoppingBtnText);
    }

    if (config.goToCartBtnText) {
        $(".advancedOrder__buttons > a").html(config.goToCartBtnText);
    }

    // "Pokračovat v nakupování" zavře colorbox
    $backBtn.off("click.advancedOrder").on("click.advancedOrder", function () {
        $("#cboxClose").click();
    });
}
